import React, { useState, useMemo, useCallback } from "react";
import { trackRaw } from "@components/click-tracker";
import { Poll } from "./poll.component.jsx";
import { useAnonymousInterceptor } from "@components/with-anonymous";
import { getNormalizer } from "./poll.util";

const normalizeAnswers = getNormalizer({
    getId: item => Number(item.id),
});

const PollContainer = React.forwardRef(
    (
        {
            answers = [],
            stats = {},
            numVotes = 0,
            userVote,
            handleVote,
            userOnly = false,
            registerLightboxId,
        },
        ref
    ) => {
        const [localUserVote, setVote] = useState();
        const _handleVote = useCallback(userVote => {
            const id = Number(userVote);
            setVote(id);
            trackRaw("answer", { id });
            if (handleVote) {
                handleVote({ id });
            }
        }, []);

        const [handleVoteUserOnly] = useAnonymousInterceptor(_handleVote, null, registerLightboxId);

        answers = useMemo(
            () => normalizeAnswers(answers, stats, numVotes, localUserVote),
            [localUserVote]
        );

        return (
            <Poll
                answers={answers}
                selected={localUserVote || userVote}
                onVote={userOnly ? handleVoteUserOnly : _handleVote}
                ref={ref}
            />
        );
    }
);

export default PollContainer;
